module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./EditProductView.js"));
	}, "EditProductView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EditProductView!./src/pages/Promote/BusinessCard/EditProduct/EditProductView.js
// module id = 1109
// module chunks = 438